<template>
  <div>
    <!-- <h5 class="checkout-h5 confirmation-title grey--text">DETALHE DO PAGAMENTO</h5> -->
    <confirmation-payment-details />
  </div>
</template>

<script>
import ConfirmationPaymentDetails from './ConformationPaymentDetails';

export default {
  components: { ConfirmationPaymentDetails },
};
</script>
